import { ParametrizationUiState } from '@/store/modules/parametrizationUi/types'

export const state: ParametrizationUiState = {
  selectedRoomId: '',
  selectedDeviceId: '',
  interacted: false,
}
